import { RubricArticle, RubricItem } from './types';

export const mockRubrics: RubricItem[] = [
  {
    id: '1',
    title: 'ТОП-5 средств для ухода за кожей с акне у подростков',
    imageUrl: 'https://placeholder.pagebee.io/api/plain/200/200',
    url: '/rubric/1'
  },
  {
    id: '2',
    title: 'Топ 5 средств месяца',
    imageUrl: 'https://placeholder.pagebee.io/api/plain/200/200',
    url: '/rubric/2'
  },
  {
    id: '3',
    title: '5 классных очищающих средств для любого типа кожи',
    imageUrl: 'https://placeholder.pagebee.io/api/plain/200/200',
    url: '/rubric/3'
  },
  {
    id: '4',
    title: 'Топ 5: подарки до 3 000 для особого случая',
    imageUrl: 'https://placeholder.pagebee.io/api/plain/200/200',
    url: '/rubric/3'
  }
];

export const mockArticle: RubricArticle = {
  id: '1',
  title: 'Первая научная конференция PRO NAS в России',
  imageUrl: 'https://placeholder.pagebee.io/api/plain/640/330',
  url: '/article/1',
  description: 'Что советует искусственный интеллект и что советует врач',
  tags: [
    {
      id: '1',
      title: 'Инновации',
      color: '#FFCC00'
    }
  ],
  meta: {
    rating: 4.5,
    readTime: '3 мин',
    date: '08.02.2025'
  }
};
